/**
 * Vista: Lista de Pedidos / Órdenes de Compra
 * Módulo unificado de compras
 */

import api from '../services/api.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem;">
          <h2 class="card-title" style="margin: 0;">Órdenes de Compra</h2>
          ${permisos.canCreate('ordenes_compra') ? `
            <button class="btn btn-primary" style="white-space: nowrap;" onclick="router.navigate('/compras/pedidos/nuevo')">
              + Nueva Orden
            </button>
          ` : ''}
        </div>

        <!-- Estadísticas -->
        <div id="statsContainer" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statPendientes" style="font-size: 1.5rem; font-weight: bold; color: var(--warning);">-</div>
            <div style="color: var(--text-muted); font-size: 0.875rem;">Pendientes</div>
          </div>
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statCompletas" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div style="color: var(--text-muted); font-size: 0.875rem;">Completas</div>
          </div>
        </div>

        <!-- Filtros -->
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input type="text" id="busqueda" class="form-input" placeholder="Folio, proveedor..." />
          </div>
          <div class="form-group">
            <label class="form-label">Estado</label>
            <select id="filtroEstado" class="form-select">
              <option value="">Todos</option>
              <option value="pendiente">Pendiente</option>
              <option value="completa">Completa</option>
            </select>
          </div>
          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.pedidosListView.limpiarFiltros()" style="width: 100%;">
              Limpiar
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Folio</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Proveedor</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="pedidosTableBody">
              <tr><td colspan="6" style="text-align: center; padding: 2rem;">Cargando...</td></tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('ordenes_compra')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.pedidosListView = this;
    this.currentPage = 1;
    this.limit = 20;
    this.filters = {};

    // Event listeners
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this._searchTimeout);
      this._searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarPedidos();
      }, 500);
    });

    document.getElementById('filtroEstado').addEventListener('change', (e) => {
      this.filters.estado = e.target.value;
      this.currentPage = 1;
      this.cargarPedidos();
    });

    await this.cargarEstadisticas();
    await this.cargarPedidos();
  },

  async cargarEstadisticas() {
    try {
      const response = await api.get('/pedidos-compra/estadisticas');
      const stats = response.data?.estadisticas || response.estadisticas || {};

      document.getElementById('statPendientes').textContent = stats.pendientes || 0;
      document.getElementById('statCompletas').textContent = stats.completas || 0;
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarPedidos() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const queryStr = Object.entries(params)
        .filter(([_, v]) => v !== undefined && v !== '')
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');

      const response = await api.get(`/pedidos-compra?${queryStr}`);
      const data = response.data || response;
      const pedidos = data.pedidos || [];
      const pagination = data.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderPedidos(pedidos);
      this.renderPaginacion(pagination);
    } catch (error) {
      console.error('Error al cargar pedidos:', error);
      toast.error('Error al cargar pedidos');
      this.renderPedidos([]);
    }
  },

  renderPedidos(pedidos) {
    const tbody = document.getElementById('pedidosTableBody');

    if (!pedidos || pedidos.length === 0) {
      tbody.innerHTML = '<tr><td colspan="6" style="text-align: center; padding: 2rem;">No se encontraron pedidos</td></tr>';
      return;
    }

    const badgeEstado = (estado) => {
      const colors = {
        'pendiente': 'badge-warning',
        'completa': 'badge-success'
      };
      const labels = {
        'pendiente': 'Pendiente',
        'completa': 'Completa'
      };
      return `<span class="badge ${colors[estado] || 'badge-secondary'}">${labels[estado] || estado}</span>`;
    };
    tbody.innerHTML = pedidos.map(p => {
      const fecha = p.fecha_pedido ? p.fecha_pedido.substring(0, 10).split('-').reverse().join('/') : '-';
      return `
        <tr>
          <td><button class="tbl-expand-btn" onclick="window.pedidosListView.toggleRow(${p.id})">&#9654;</button></td>
          <td><strong>${p.folio}</strong></td>
          <td class="tbl-hide-mobile">${fecha}</td>
          <td class="tbl-hide-mobile">${p.proveedor_nombre || '-'}</td>
          <td class="tbl-hide-mobile">${badgeEstado(p.estado)}</td>
          <td class="tbl-hide-mobile">
            <div style="display: flex; gap: 0.5rem;">
              ${p.estado === 'completa'
                ? (permisos.canView('ordenes_compra') ? `<button class="btn btn-sm btn-primary" onclick="window.pedidosListView.verDetalle(${p.id})">Ver</button>` : '')
                : `${permisos.canEdit('ordenes_compra') ? `<button class="btn btn-sm btn-primary" onclick="window.pedidosListView.verDetalle(${p.id})">Editar</button>` : ''}
                   ${permisos.canDelete('ordenes_compra') ? `<button class="btn btn-sm btn-danger" onclick="window.pedidosListView.eliminar(${p.id}, '${p.folio}')">Eliminar</button>` : ''}`
              }
            </div>
          </td>
        </tr>
        <tr class="tbl-detail-row" id="detail-ped-${p.id}">
          <td colspan="6" class="tbl-detail-cell">
            <dl class="tbl-detail-grid">
              <dt>Fecha</dt><dd>${fecha}</dd>
              <dt>Proveedor</dt><dd>${p.proveedor_nombre || '-'}</dd>
              <dt>Estado</dt><dd>${badgeEstado(p.estado)}</dd>
            </dl>
            <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
              ${p.estado === 'completa'
                ? (permisos.canView('ordenes_compra') ? `<button class="btn btn-sm btn-primary" onclick="window.pedidosListView.verDetalle(${p.id})">Ver</button>` : '')
                : `${permisos.canEdit('ordenes_compra') ? `<button class="btn btn-sm btn-primary" onclick="window.pedidosListView.verDetalle(${p.id})">Editar</button>` : ''}
                   ${permisos.canDelete('ordenes_compra') ? `<button class="btn btn-sm btn-danger" onclick="window.pedidosListView.eliminar(${p.id}, '${p.folio}')">Eliminar</button>` : ''}`
              }
            </div>
          </td>
        </tr>
      `;
    }).join('');
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) { container.innerHTML = ''; return; }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';
    html += `<button class="btn btn-sm btn-secondary" onclick="window.pedidosListView.cambiarPagina(${page - 1})" ${page === 1 ? 'disabled' : ''}>Anterior</button>`;

    for (let i = 1; i <= totalPages; i++) {
      if (i === page) {
        html += `<button class="btn btn-sm btn-primary" disabled>${i}</button>`;
      } else if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `<button class="btn btn-sm btn-secondary" onclick="window.pedidosListView.cambiarPagina(${i})">${i}</button>`;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span>...</span>';
      }
    }

    html += `<button class="btn btn-sm btn-secondary" onclick="window.pedidosListView.cambiarPagina(${page + 1})" ${page === totalPages ? 'disabled' : ''}>Siguiente</button>`;
    html += '</div>';
    container.innerHTML = html;
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-ped-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarPedidos();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('filtroEstado').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarPedidos();
  },

  verDetalle(id) {
    router.navigate(`/compras/pedidos/${id}`);
  },

  eliminar(id, folio) {
    modal.confirm(
      'Eliminar Pedido',
      `¿Está seguro de eliminar el pedido ${folio}?`,
      async () => {
        try {
          await api.delete(`/pedidos-compra/${id}`);
          toast.success('Pedido eliminado');
          await this.cargarEstadisticas();
          await this.cargarPedidos();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar');
        }
      }
    );
  }
};
